import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
// import CircularProgress from '@mui/material/CircularProgress'; // Asegúrate de tener MUI instalado
// import Box from '@mui/material/Box';

import {
  CreateNewTabsButton,
  MyTicketsButton,
  CidrCalculatorButton,
  XRayButton,
  WhoisButton,
  OUIButton,
  BicomButton,
} from '../../components/ui/DashboardButtons.jsx';

function Home() {
  const { user } = useAuth();

  return (
    <div>
      {
        user ? HomeZones() : LandingScreen()
        // <div>
        //   <h1>Not logged in {message}</h1>
        //   <p>You are not logged in</p>
        //   <Link to="/login">Login</Link>
        // </div>
      }
    </div>
  );
}

export default Home;

const HomeZones = () => {
  return (
    <div
      className="w-screen bg-neutral-100 flex flex-col items-center p-4 gap-4"
      style={{ height: 'calc(100vh - 5rem)' }} // o '80vh' si querés menos
    >
      {/* Bottom Sections */}
      <div className="flex flex-col md:flex-row gap-6 max-w-5xl w-full justify-center">
        {/* Smart Tickets */}
        <div className="bg-blue-400 text-white p-4 rounded-md border-2 border-white w-full md:w-1/2 shadow-md rounded-xl">
          <h2 className="text-lg font-bold mb-4 text-center">SMART TICKETS</h2>
          
          {/* Smart Tickets Image */}
          <div className="flex justify-center mb-4">
            <img 
              src="/img/smart-ticket.png" 
              alt="Smart Tickets" 
              className="max-w-full h-auto rounded-lg shadow-sm"
              style={{ maxHeight: '150px' }}
            />
          </div>
          
          <div className="flex flex-col gap-4 items-center">
            <CreateNewTabsButton />
            <MyTicketsButton />
          </div>
        </div>

        {/* Isolated Tools */}
        <div className="bg-green-500 text-white p-4 rounded-md border-2 border-white w-full md:w-1/2 shadow-md rounded-xl">
          <h2 className="text-lg font-bold mb-4 text-center">ISOLATED TOOLS</h2>
          
          {/* Isolated Tools Image */}
          <div className="flex justify-center mb-4">
            <img 
              src="/img/isolated-tools.png" 
              alt="Isolated Tools" 
              className="max-w-full h-auto rounded-lg shadow-sm"
              style={{ maxHeight: '150px' }}
            />
          </div>
          
          <div className="flex flex-col gap-4 items-center">
            <div className="flex gap-4 w-full">
              <div className="w-1/2">
                <CidrCalculatorButton />
              </div>
              <div className="w-1/2">
                <XRayButton />
              </div>
            </div>
            <div className="flex gap-4 w-full">
              <div className="w-1/2">
                <WhoisButton />
              </div>
              <div className="w-1/2">
                <OUIButton />
              </div>
            </div>
            <div className="flex gap-4 w-full">
              <div className="w-full">
                <BicomButton />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const LandingScreen = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <div className="relative min-h-screen bg-white overflow-hidden">
        {/* Background image */}
        <div
          className="absolute top-0 right-0 h-full w-3/4 bg-cover bg-center z-0"
          style={{ backgroundImage: "url('/img/support-agent.jpg')" }}
        ></div>

        {/* Gradient white overlay from left to right */}
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-white/0 z-10" />

        {/* Content */}
        <div className="relative z-20 flex flex-col md:flex-row items-stretch min-h-screen">
          <div className="w-full md:w-1/2 p-10 flex flex-col justify-center">
            <p className="text-sm font-semibold text-red-600 uppercase mb-4">
              Support Services
            </p>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Start improving <br className="hidden md:block" /> your support
              today
            </h1>
            <p className="text-gray-700 text-lg mb-8">
              Our customers deserve fast, reliable, and effective support.{' '}
              <br className="hidden md:block" />
              We help you simplify your processes, reduce response times,{' '}
              <br className="hidden md:block" />
              and enhance your team's performance—starting now.
            </p>

            <Link
              to="/login"
              className="bg-red-600 text-white px-10 py-4 rounded-md text-base text-center hover:bg-red-700 transition w-max"
            >
              Start now
            </Link>
          </div>
          {/* Right spacer to maintain layout */}
          <div className="hidden md:block w-1/2" />
        </div>
      </div>

      {/* Scrollable Content Section */}
      <div className="flex-1 overflow-y-auto bg-red-600 p-10">
        <div className="max-w-4xl mx-auto"></div>
      </div>

      <div className="flex-1 overflow-y-auto bg-grey-800 p-10">
        <div className="max-w-6xl mx-auto">
          {/* Feature Cards */}
          <div className="bg-white rounded-2xl shadow-lg p-6 mt-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-4xl mb-4">🖥️</div>
              <h3 className="text-xl font-semibold mb-2">Automation</h3>
              <p className="text-gray-600 text-sm">
                Ticket classification, smart assignments, automatic responses,
                etc.
              </p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-4">⚙️</div>
              <h3 className="text-xl font-semibold mb-2">Customizable Plans</h3>
              <p className="text-gray-600 text-sm">
                Flexible support packages tailored to your company's industry
                and scale.
              </p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-4">📊</div>
              <h3 className="text-xl font-semibold mb-2">
                Analytics & Insights
              </h3>
              <p className="text-gray-600 text-sm">
                Gain valuable metrics on ticket flow, response time, and team
                efficiency.
              </p>
            </div>
          </div>

          {/* Section title */}
          <h2 className="text-2xl font-bold mt-16 mb-4 text-center">
            Find out how we can improve your{' '}
            <span className="text-red-500">system</span>.
          </h2>

          {/* More content suggestions */}
          <div className="text-center mt-8">
            <p className="text-gray-700 mb-2">
              From IT to healthcare, our intelligent support system adapts to
              your business.
            </p>
            <p className="text-gray-700 mb-2">
              No matter your sector—retail, services, logistics, finance—we
              offer the right plan for you.
            </p>
            <p className="text-gray-700">
              Talk to our team and we'll build the support experience you need.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};